//icons
import CartIcon from "../../assets/cart.svg";
import OrderIcon from "../../assets/order.svg";

//styles
import styles from "./SystemMessage.module.css";

//tools
import { $translation } from "../../tools/helpers";

const SystemMessage = ({ message }) => {
	if (message.purpose === "product_added") {
		const additionalParameters = window.safely_parse_json(
			message.additional_parameters
		);

		const onClick = (e) => {
			e.preventDefault();
			if (!additionalParameters.product_id) return;

			window.store.emit("show_modal", {
				entry_key: "product",
				entry_data: { productId: additionalParameters.product_id },
			});
		};
		
		return (
			<div
				className={styles["message-system"]}
				onClick={onClick}>
				<img
					className={styles["message-system-image-cart"]}
					src={CartIcon}
				/>
				<span>{$translation(message?.text)}</span>
			</div>
		);
	} else if (message.purpose === "order_confirmed") {
		const additionalParameters = window.safely_parse_json(
			message.additional_parameters
		);

		const onClick = (e) => {
			e.preventDefault();
			if (!additionalParameters.order_guid) return;

			__cng_common.load_page_ajax(
				__cng_common.build_url("/bill/", { oguid: additionalParameters.order_guid })
			);

			window.store.emit("hide_chat");
		};
		
		return (
			<div
				className={styles["message-system"]}
				onClick={onClick}>
				<img
					className={styles["message-system-image-cart"]}
					src={OrderIcon}
				/>
				<span>{$translation(message?.text)}</span>
			</div>
		);
	}

	return (
		<div className={styles["message-system"]}>
			{$translation(message?.text)}
		</div>
	);
};

export default SystemMessage;
